import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";

export interface ITaskDynamicFormLineBreakProp {
    taskTypeCol: ITaskTypeCol;
}

export class TaskDynamicFormLineBreak extends React.Component<ITaskDynamicFormLineBreakProp, {}> {
    render() {
        return (
            <div className="lineBreak"></div>
        );
    }
}